import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable()
export class SelectAdminsAnalytics extends AnalyticsBase {
  public readonly namespace = 'Select admins';
  public readonly requireViewContext = true;

  public selectAll() {
    this.track('Select all', {});
  }

  public selectNone() {
    this.track('Select none');
  }
}
